import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	showMoreLabel: {
		id: 'search-page.app-filter-sidebar.show-more.button.label',
		defaultMessage: 'Show more',
		description: 'Label for the button that opens the show more apps dialog',
	},
	filterPlaceholder: {
		id: 'search-page.app-filter-sidebar.show-more.filter.placeholder',
		defaultMessage: 'Find apps',
		description: 'Placeholder for the filter input in the show more apps dialog',
	},
});
